const css = `
    body pre{
        font-family: "Open Sans", sans-serif;
        margin: 0;
        font-weight: 400;
        white-space: break-spaces;
    }
    body .cke_widget_embed {
        max-width: 320px;
        min-width: auto;
    }
    body img {
        max-width:100%;
        height: auto !important;
    }
    .spinner-border {
        display: inline-block;
        width: 2rem;
        height: 2rem;
        vertical-align: text-bottom;
        border: 0.25em solid currentColor;
        border-right-color: transparent;
        border-radius: 50%;
        -webkit-animation: spinner-border 0.75s linear infinite;
        animation: spinner-border 0.75s linear infinite;
    }
    @keyframes spinner-border {
        to { transform: rotate(360deg); }
    }
`
export default css
